module.exports = __webpack_public_path__ + "img/ddwu_gallery12.1ac29829.jpg";